import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotesStore } from '../store';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function CalendarView() {
  const navigate = useNavigate();
  const { notes } = useNotesStore();
  const [currentDate, setCurrentDate] = useState(new Date());

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const notesByDate = {};
  notes.forEach(n => {
    const d = new Date(n.updated_at);
    if (d.getMonth() === month && d.getFullYear() === year) {
      const day = d.getDate();
      if (!notesByDate[day]) notesByDate[day] = [];
      notesByDate[day].push(n);
    }
  });

  const prevMonth = () => setCurrentDate(new Date(year, month - 1));
  const nextMonth = () => setCurrentDate(new Date(year, month + 1));

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">{currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</h3>
        <div className="flex gap-1">
          <Button variant="ghost" size="icon" onClick={prevMonth}><ChevronLeft size={16} /></Button>
          <Button variant="ghost" size="icon" onClick={nextMonth}><ChevronRight size={16} /></Button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-px bg-border">
        {DAYS.map(d => <div key={d} className="bg-muted p-2 text-center text-xs font-medium text-muted-foreground">{d}</div>)}
        {Array.from({ length: firstDay }).map((_, i) => <div key={`empty-${i}`} className="bg-background p-2 min-h-[80px]" />)}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          const dayNotes = notesByDate[day] || [];
          return (
            <div key={day} className="bg-background p-2 min-h-[80px] hover:bg-muted/50 transition-colors">
              <div className="text-xs text-muted-foreground mb-1">{day}</div>
              {dayNotes.slice(0, 3).map(n => (
                <button
                  key={n.id}
                  onClick={() => navigate(`/note/${n.id}`)}
                  className="w-full text-left text-xs p-1 rounded bg-primary/10 text-primary truncate mb-0.5 hover:bg-primary/20"
                >
                  {n.title}
                </button>
              ))}
              {dayNotes.length > 3 && <div className="text-xs text-muted-foreground">+{dayNotes.length - 3} more</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
